import { debounce } from 'lodash-es';

// 0.1 表示 10% 的采样率
const isReport = Math.random() < 0.1;
let isFirst = true;
let navigationStart = 0;

const startApp = (reportParams = {}) => {
  try {
    if (!window.performance || !isReport) return;
    isFirst = true;
    window.REPORT_TRACK('web_vitals_performance_monitoring', {
      ...reportParams,
      indicator: 'start_app',
      consum_time: Math.round(performance.now()),
    });
  } catch (e) {
    window.REPORT_TRACK('web_error_log', {
      fail_reason: 'web_vitals_performance_monitoring: start_app',
    });
  }
};

const pageBeforeEach = () => {
  try {
    if (!window.performance || !isReport) return;
    navigationStart = isFirst ? 0 : performance.now();
    isFirst = false;
  } catch (e) {
    window.REPORT_TRACK('web_error_log', {
      fail_reason: 'web_vitals_performance_monitoring: page_before_each',
    });
  }
};

const pageBeforeCreate = (reportParams = {}) => {
  try {
    if (!window.performance || !isReport) return;
    window.REPORT_TRACK('web_vitals_performance_monitoring', {
      ...reportParams,
      indicator: 'page_before_create',
      consum_time: Math.round(performance.now() - navigationStart),
    });
  } catch (e) {
    window.REPORT_TRACK('web_error_log', {
      fail_reason: 'web_vitals_performance_monitoring: page_before_create',
    });
  }
};

const pageMounted = (reportParams = {}) => {
  try {
    if (!window.performance || !isReport) return;
    window.REPORT_TRACK('web_vitals_performance_monitoring', {
      ...reportParams,
      indicator: 'page_mounted',
      consum_time: Math.round(performance.now() - navigationStart),
    });
  } catch (e) {
    window.REPORT_TRACK('web_error_log', {
      fail_reason: 'web_vitals_performance_monitoring: page_mounted',
    });
  }
};

const pageLoadingToastEnd = (reportParams = {}) => {
  try {
    if (!window.performance || !isReport) return;
    const body = document.body || document.getElementsByTagName('body')[0];
    if (!(window.MutationObserver && body && document?.querySelector)) {
      return;
    }
    const hasLoadingToast = () => document.querySelector('body > .ms-toast');
    // 监听 body 子节点变化
    const observer = new window.MutationObserver((mutations) => {
      function isElement(node: Node): node is Element {
        return node.nodeType === Node.ELEMENT_NODE;
      }
      // 本次更新是否包含 .ms-toast 添加或移除
      const hasLoadingToastChange = mutations.some((mutation) => {
        return (
          mutation.type === 'childList' &&
          (Array.from(mutation.addedNodes).some(
            (item) => isElement(item) && item.className?.includes('ms-toast'),
          ) ||
            Array.from(mutation.removedNodes).some(
              (item) => isElement(item) && item.className?.includes('ms-toast'),
            ))
        );
      });
      // 本次更新包含 .ms-toast 添加或移除
      if (hasLoadingToastChange) {
        if (!hasLoadingToast()) {
          delayReport();
        } else {
          delayReport.cancel();
        }
      }
    });
    observer.observe(body, {
      childList: true,
      subtree: false,
      attributes: false,
      characterData: false,
    });
    // 200ms 后上报埋点并移除监听，若多次调用则延后上报
    const delayReport = debounce(() => {
      observer.disconnect();
      window.REPORT_TRACK('web_vitals_performance_monitoring', {
        ...reportParams,
        indicator: 'page_loading_toast_end',
        consum_time: Math.round(performance.now() - navigationStart - 200),
      });
    }, 200);

    if (!hasLoadingToast()) {
      delayReport();
    }
  } catch (e) {
    window.REPORT_TRACK('web_error_log', {
      fail_reason: 'web_vitals_performance_monitoring: page_loading_toast_end',
    });
  }
};

export default { startApp, pageBeforeEach, pageBeforeCreate, pageMounted, pageLoadingToastEnd };
